export default __webpack_public_path__ + "static/spray-edge-3-63b3e8021334062b57f2ac83c2f365e1.webp";